import { WebResponse } from "@app/shared/interfaces/webResponse.interface";
import { createAction, props } from "@ngrx/store";
import { PortalRequest } from "../interfaces/portalRequest.interface";
import { UserStatusInfo } from "../interfaces/userStatusInfo.interface";
import {
  PageSearchSortOptions
} from "@app/shared/interfaces/pageSearchSortOptions.interface";
import { PaginatedResult } from "@app/shared/interfaces/paginatedResult.interface";
import { CaseContact } from "@app/shared/interfaces/caseContact.interface";
import { Clinic } from "@app/shared/interfaces/clinic.interface";
import { Provider } from "@app/shared/interfaces/provider.interface";
import {AuthResponse} from "@app/features/login/interfaces/authResponse.interface";
import {UserFilterOptions} from "@app/shared/interfaces/userFilterOptions.interface";
import {UserPageRequest} from "@app/features/adminDashboard/interfaces/userPageRequest.interface";

export const FetchPortalRequests = createAction(
  '[Admin] Fetch Portal Requests List'
);

export const FetchPortalRequestsSuccess = createAction(
  '[Admin] Fetch Portal Requests List Success',
  props<{ portalRequests: WebResponse<PortalRequest[]> }>()
);

export const FetchAllSystemUsers = createAction(
  '[Admin] Fetch All System Users',
  props<{ userPageRequest: UserPageRequest }>()
);

export const FetchAllSystemUsersSuccess = createAction(
  '[Admin] Fetch All System Users Success',
  props<{ users: WebResponse<PaginatedResult<UserStatusInfo>> }>()
);

export const FetchCaseContacts = createAction(
  '[Admin] Fetch Case Contacts'
);

export const FetchCaseContactsSuccess = createAction(
  '[Admin] Fetch Case Contacts Success',
  props<{ caseContacts: CaseContact[] }>()
);

export const FetchClinics = createAction(
  '[Admin] Fetch Clinics'
);

export const FetchClinicsSuccess = createAction(
  '[Admin] Fetch Clinics Success',
  props<{ clinics: Clinic[] }>()
);

export const FetchProviders = createAction(
  '[Admin] Fetch Providers'
);

export const FetchProvidersSuccess = createAction(
  '[Admin] Fetch Providers Success',
  props<{ providers: Provider[] }>()
);

export const CaseContactSearchTermChanged = createAction(
  '[Admin] Case Contact Search Term Changed',
  props<{ searchTerm: string }>()
);
